export default __webpack_public_path__ + "static/media/game-back-icon-hover.da131bae.svg";